export const getString = (value: string | null) => {
    try {
        if (value == null || value.trim() === '') return '-';

        return value.toString();
    } catch (err) {
        return '-';
    }
};

export const getInt = (value: number | null) => {
    try {
        if (value == null || value.toString() === '' || typeof value === 'undefined') return '-';

        return value.toString();
    } catch (err) {
        return '-';
    }
};

export function getSumFromItems(obj: any) {
    let sum = 0;
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            sum += obj[key].zvltotal;
        }
    }
    return sum;
}

export const isFilled = (value: any) => {
    return !isBlank(value);
};

export const isBlank = (value: any) => {
    if (isNull(value)) {
        return true;
    }

    if (isString(value)) {
        return value.trim() === '';
    }

    if (isNumeric(value) || isBool(value)) {
        return value.trim() === '';
    }

    if (isCountable(value)) {
        return count(value) === 0;
    }

    if (isObjectEmpty(value)) {
        return true
    }

    return true;
};

export const isNumeric = (value: any) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
};

export const isString = (value: any) => {
    return typeof value === 'string' || value instanceof String;
};

export const isNull = (value: any) => {
    return value === null || value === undefined;
};

export const isCountable = (value: any) => {
    if (typeof value === 'object' && value.hasOwnProperty('length')) {
        return true;
    }

    if (Array.isArray(value)) {
        return true;
    }

    return false;
};

export const count = (value: any) => {
    if (Array.isArray(value) || typeof value === 'string') {
        return value.length;
    }

    if (typeof value === 'object' && value !== null && 'count' in value) {
        return value.count();
    }

    return 0;
};

export const isBool = (value: any) => {
    return typeof value === 'boolean';
};

export const isObjectEmpty = (obj: any) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};
